import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
//import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';


@Component({
  selector: 'kt-filter-category-dialog',
  templateUrl: './filter-category-dialog.component.html',
  styleUrls: ['./filter-category-dialog.component.scss']
})
export class FilterCategoryDialogComponent {
  constructor(public dialogRef: MatDialogRef<FilterCategoryDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: { category: string; description: string }) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close();
  }
}